export const HOME_PAGE = '';
export const SEARCH_PAGE = '/search';
export const CATEGORY_PAGE = '/categories/[categoryId]';
export const PRODUCT_DETAIL_PAGE = '/products/[sku]';
export const LANDING_PAGE = '/landing/[id]';
export const BRAND_PAGE = '/brands/[brandId]';
export const MASTER_CATEGORY_PAGE = '/block-categories/[categoryId]';
export const SELLER_CATEGORY_PAGE = '/seller-categories/[categoryId]';
export const SELLER_PAGE = '/sellers/[sellerId]';
export const COMBO_LIST = '/products/[sku]/combos';
export const COMBO_DETAIL = '/products/[sku]/combos/[id]';
export const PROVIDER_PAGE = '/cua-hang/[providerId]';
export const LANDING_BUILDER_PAGE = '/p/[slug]';

export const TRACKING_SCREEN_MAPPING: Record<string, string> = {
  [HOME_PAGE]: 'homePage',
  [SEARCH_PAGE]: 'searchProductResult',
  [CATEGORY_PAGE]: 'category',
  [BRAND_PAGE]: 'brandPage',
  [PRODUCT_DETAIL_PAGE]: 'productDetail',
  [LANDING_PAGE]: 'landingPage',
  [MASTER_CATEGORY_PAGE]: 'masterCategoryPage',
  [SELLER_CATEGORY_PAGE]: 'sellerCategoryPage',
  [SELLER_PAGE]: 'sellerPage',
  [COMBO_LIST]: 'comboList',
  [COMBO_DETAIL]: 'comboDetail',
  [PROVIDER_PAGE]: 'providerPage',
  [LANDING_BUILDER_PAGE]: 'landingPage',
};
